import { IResourceComponentsProps } from "@refinedev/core";
import { AntdListInferencer } from "@refinedev/inferencer/antd";
import Cw8List from "components/cw8/Cw8List";

export const FragmentObjectsList: React.FC<IResourceComponentsProps> = () => {
  const resourceName :string = 'fragmentObject';
  return (
    <Cw8List
      resourceName = {resourceName}
    ></Cw8List>
  );
};
